const initChooserVisual = async() => {
	const section = document.querySelector( 'section.chooser-visual' );

	if ( !section ) {
		return;
	}

	let statuses;

	const getStatus = async () => {
			await fetch( '/api/rooms/?mode=status-only&complex=43336', {
				method: 'GET',
				credentials: 'same-origin',
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
					'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
				},
				
			} )
				.then( ( response ) => {
					if ( !response.ok )
					{
						throw new Error( `Could not fetch, status: ${response.status}` );
					}
					return response.json();
				} )
				.then( ( data ) => { 
					statuses = data;
				})
	};
	getStatus();

	const isEn = document.querySelector( 'body' ).classList.contains( 'en' );
	const data = JSON.parse(section.getAttribute( 'data' ));
	const pins = section.querySelectorAll( 'g .pin' );

	let sectionYDiff = section.getBoundingClientRect().top;

	window.addEventListener( 'scroll', ( e ) => {
		sectionYDiff = section.getBoundingClientRect().top;
	})	
	
	const tooltip = section.querySelector( '.tooltip' );
	
	let currentBuilding;

	const initMouseMove = () => {
		document.onmousemove = function(e) {
			const target = e.target.parentNode;
			if ( (target.hasAttribute( 'building-id' )) && ( e.target !== tooltip ) ) {
				let currentPinRight;
				let currentPinTop;
				if ( target.classList.contains( 'pin' )) {
					if ( window.innerWidth > 768 ) {
						currentPinTop = target.getBoundingClientRect().top
						currentPinRight = target.getBoundingClientRect().right;
					}
				} else 
				{
					if ( window.innerWidth > 768 ) {
					currentPinTop = target.firstElementChild.getBoundingClientRect().top - sectionYDiff;
					currentPinRight = target.firstElementChild.getBoundingClientRect().right - 100;
					}
				}
	
				if ( target.getBoundingClientRect().left > window.innerWidth / 2 ) {
					currentPinRight += 70;
					if ( window.innerWidth > 768 ) {
						tooltip.classList.add( 'right-mode' );
					}
				} else 
				{
					tooltip.classList.remove( 'right-mode' );
				}
	
				tooltip.style.display = 'block';
				tooltip.style.top = `${currentPinTop}px`;
				tooltip.style.left = `${currentPinRight}px`;
				tooltip.firstElementChild.innerText = `${isEn ? 'Building' : 'Корпус' } ${target.getAttribute( 'building-id' ).toUpperCase()}`;
				currentBuilding = target.getAttribute( 'building-id' );
			} else if ( !e.target.closest( '.tooltip' ) ) {
				tooltip.style.display = 'none';
				tooltip.childNodes[0].style.display = 'block';
				tooltip.childNodes[2].style.display = 'none';	
			} 
		}
	}

	initMouseMove();

	const ButtonsLevel = tooltip.querySelectorAll( '.button-level' );

	section.addEventListener( 'click', (e) => {

		if (e.target.classList.contains( 'stage-1' ) || e.target.closest( '.hover-element' )) {
			const keys = Object.keys(data[currentBuilding.toUpperCase()]);
			ButtonsLevel[0].innerText = keys[2];
			ButtonsLevel[1].innerText = keys[1];
			ButtonsLevel[2].innerText = keys[0];
			ButtonsLevel[0].href = `/projects/maestro/apartments/${data[currentBuilding.toUpperCase()][keys[2]]}/`;
			ButtonsLevel[1].href = `/projects/maestro/apartments/${data[currentBuilding.toUpperCase()][keys[1]]}/`;
			ButtonsLevel[2].href = `/projects/maestro/apartments/${data[currentBuilding.toUpperCase()][keys[0]]}/`;
	
			if (statuses[data[currentBuilding.toUpperCase()][keys[2]]] === 'sold') {
				ButtonsLevel[0].classList.add('sold');
				if ( window.innerWidth > 768 ) {
					ButtonsLevel[0].innerText += ' (sold)';
				}
			};
			if (statuses[data[currentBuilding.toUpperCase()][keys[1]]] === 'sold') {
				ButtonsLevel[1].classList.add('sold');
				if ( window.innerWidth > 768 ) {
					ButtonsLevel[1].innerText += ' (sold)';
				}
			};
			if (statuses[data[currentBuilding.toUpperCase()][keys[0]]] === 'sold') {
				ButtonsLevel[2].classList.add('sold');
				if ( window.innerWidth > 768 ) {
					ButtonsLevel[2].innerText += ' (sold)';
				}
			};

			if ( window.innerWidth > 768 ) {
				tooltip.childNodes[0].style.display = 'none';
			} else 
			{
				document.querySelector( 'html' ).style.overflow = "hidden";
				document.querySelector( 'body' ).classList.add( 'tooltip-show' );
				tooltip.style.transform = 'none';
				var xDown = null;                                                        
				var yDown = null;                                                        

				const handleTouchStart = (evt) => {                                      
					xDown = evt.touches[0].clientX;                                      
					yDown = evt.touches[0].clientY;                                      
				}; 

				const touchHandle = (evt) => {
				if ( ! xDown || ! yDown ) {
						return;
					}

					var xUp = evt.touches[0].clientX;                                    
					var yUp = evt.touches[0].clientY;

					var xDiff = xDown - xUp;
					var yDiff = yDown - yUp;

					if ( Math.abs( xDiff ) < Math.abs( yDiff ) ) {
						if ( yDiff < 0 ) { 
							tooltip.style.transform = 'translateY(100%)';
							document.querySelector( 'body' ).classList.remove( 'tooltip-show' );
							document.querySelector( 'html' ).style.overflow = "visible";
						}                                                                 
					}
					xDown = null;
					yDown = null; 
				}
				tooltip.addEventListener( "touchstart", handleTouchStart );
				tooltip.addEventListener( "touchmove", touchHandle );
			}
			tooltip.childNodes[2].style.display = 'flex';
			section.querySelector( 'svg image' ).setAttribute( 'xlink:href', `/images/complex/maestro/visual/${currentBuilding}.webp` );
			pins.forEach( item => {
				item.style.opacity = '0';
			} )
			let currentLevel;
			document.onmousemove = function(event) {
				if ( event.target.classList.contains( 'button-level' ) ) {
					currentLevel = section.querySelector(`[building-id="${currentBuilding}"] .${event.target.getAttribute( 'data-level' )}`);	
					if ( currentLevel ) {
						currentLevel.classList.add( 'active' );
					} 
				} else 
				{
					if ( currentLevel ) {
						currentLevel.classList.remove( 'active' );
					} 
				}
			}
		} 
		
	} )	

	document.addEventListener( 'click', (e) => {
		if ( !e.target.closest( '.tooltip' ) && !e.target.closest( '.hover-element' )) {
			section.querySelector( 'svg image' ).setAttribute( 'xlink:href', '/images/complex/maestro/visual/plan.webp' );
			tooltip.style.display = 'none';
			tooltip.childNodes[0].style.display = 'block';
			tooltip.childNodes[2].style.display = 'none';

			ButtonsLevel.forEach(item => {
				item.classList.remove('sold');
			})

			if ( window.innerWidth < 768 ) {
				tooltip.style.transform = 'translateY(100%)';
				document.querySelector( 'html' ).style.overflow = "visible";
				document.querySelector( 'body' ).classList.remove( 'tooltip-show' );
			}
			initMouseMove();
			pins.forEach( item => {
				item.style.opacity = '1';
			} )
		}
	} )
}

export {
	initChooserVisual,
};